// STAREA INSTALAȚIILOR pe un ecran: modelul arătat, ce sisteme se văd și ce
// element e ales. O ține pagina (`pages/Instalatii.tsx`); vizualizatorul o
// citește, ca să deseneze straturile în 2D și 3D, iar panoul ca să arate
// verificările. Fără furnizor, `useInstalatii()` e `null` și vizualizatorul
// rămâne cum era — așa poate primi stratul orice alt ecran, mai târziu.

import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";
import { SISTEME, type ModelInstalatii, type Sistem } from "./model";

export interface StareInstalatii {
  model: ModelInstalatii;
  vizibile: ReadonlySet<Sistem>;
  comuta(sisteme: readonly Sistem[], aprins: boolean): void;
  ales: string | null;
  alege(id: string | null): void;
}

const Ctx = createContext<StareInstalatii | null>(null);

export function FurnizorInstalatii({ model, children }: { model: ModelInstalatii; children: ReactNode }) {
  const [vizibile, setVizibile] = useState<ReadonlySet<Sistem>>(
    () => new Set(SISTEME.map((s) => s.sistem)));
  const [ales, setAles] = useState<string | null>(null);
  const comuta = useCallback((sisteme: readonly Sistem[], aprins: boolean) => setVizibile((v) => {
    const nou = new Set(v);
    for (const s of sisteme) { if (aprins) nou.add(s); else nou.delete(s); }
    return nou;
  }), []);
  const valoare = useMemo<StareInstalatii>(() => ({ model, vizibile, comuta, ales, alege: setAles }),
                                           [model, vizibile, comuta, ales]);
  return <Ctx.Provider value={valoare}>{children}</Ctx.Provider>;
}

export const useInstalatii = () => useContext(Ctx);
